exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, ".no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.dialog-button{font-family:Open Sans,sans-serif;font-weight:400;text-align:center;font-size:15px;color:#8b8b8b;letter-spacing:1.5px;height:40px;border:none;cursor:pointer}.dialog-button:hover{color:#000}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Buttons/DialogButton/DialogButton.scss
// module id = 1525
// module chunks = 0